<template>
  <div>
    <main-layout
      controlsBg="light"
      :hasControlsBar="false"
      :breadcrumb="getBreadcrumb">
      <div class="container">
        <grid-row  class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <div>
              <h1 class="header-title">
                {{ $t('xugarhero.game.ranking') }}
              </h1>
            </div>
          </grid-col>
        </grid-row>
        <grid-row  class="margin-top-l" column-align="center">
          <grid-col col-size="4">
            <table-component
              :data="getGameRanking"
              sort-by="rank"
              sort-order="asc"
              :show-caption="false"
              class="datatable"
              filter-placeholder=""
              filterNoResults="">
              <table-column
                show="rank"
                dataType="numeric"
                cell-class="cell-text text-center"
                :sortable="true"
                :filterable="false">
              </table-column>
              <table-column
                show="username"
                :sortable="true"
                :filterable="true">
              </table-column>
              <table-column
                show="nickname"
                :sortable="true"
                :filterable="true">
              </table-column>
              <table-column
                show="score"
                cell-class="cell-text text-center"
                :sortable="false"
                :filterable="false">
              </table-column>
            </table-component>
          </grid-col>
        </grid-row>
      </div>
    </main-layout>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import MainLayout from '@/layouts/MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import TableColumn from '@/components/shared/table/components/TableColumn';
import TableComponent from '@/components/shared/table/components/TableComponent';

export default {
  components: {
    TableComponent,
    TableColumn,
    MainLayout,
    GridRow,
    GridCol
  },
  created () {
    this.retrieveGameRanking({ context: this });
  },
  computed: {
    ...mapGetters([
      'getGameRanking'
    ]),
    getBreadcrumb () {
      return [
        {name: this.$t('xugarhero.game.ranking'), disabled: true}
      ];
    }
  },
  methods: {
    ...mapActions([
      'retrieveGameRanking'
    ])
  }
};
</script>

<style lang="scss" scoped>
  @import "src/stylesheets/variables";

  .header-title {
    float: left;
  }

</style>



// WEBPACK FOOTER //
// src/brand/xugarhero/layouts/GameRanking.vue